import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../redux/store";
import { ScheduleV2 } from "../../../types";
import { DateTimeUtil } from "../../../utils";
import { getMyScheduleDetails } from "../../../redux/features/schedule/ScheduleApi";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";

const EventCard: React.FC<{ schedule: ScheduleV2 }> = ({ schedule }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleClick = () => {
        dispatch(getMyScheduleDetails({
            schedule_id: schedule.schedules_id?.toString()
        }));
        dispatch(setTopNavNameTitle("Schedule Details"));
        navigate("/m-schedule-details");
    };

    const shiftName = schedule.shift?.shift_name || "Untitled Event";
    const dateRange = DateTimeUtil.formatElegantTimeRange(schedule?.start_time, schedule?.end_time);

    return (
        <div
            key={schedule.schedules_id}
            className="flex items-start w-full p-3 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition relative"
            onClick={handleClick}
        >
            {/* Red Bar on the Left */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-500 rounded-l-lg"></div>

            {/* Content Section */}
            <div className="flex flex-row justify-center items-start gap-2 text-center ml-4">
                <h3 className="font-bold text-gray-800 text-sm">{shiftName}</h3> 
                <p className="text-gray-500 text-sm">{dateRange}</p>
            </div>
        </div>
    );
};

export default EventCard;
